import { render } from "./View03.vue?vue&type=template&id=89f309ca&scoped=true"
import script from "./View03.vue?vue&type=script&lang=js"
export * from "./View03.vue?vue&type=script&lang=js"

import "./View03.vue?vue&type=style&index=0&id=89f309ca&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89f309ca"]])

export default __exports__